/**
 * 绑定手机
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import Cache from 'c-cache';
import notification from 'c-notification';
import Modal from 'boron/ScaleModal';
import loading from 'c-up-loading';
import lang from '../../lang';
import sensitive from '../sensitive-words';
import CountryView from './country-view';

import ProfileSet from '../profile/set';

let cache = new Cache({
    prefix: 'pcuplive'
});

const noop = function(){};

const style = {
    modalStyle: {
         width: '400px',
         zIndex: 1070
    },
    contentStyle: {
        width: '400px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)",
        zIndex: 1060
    }
}


class SelectCountry  extends Component {
    static defaultProps = {
        content: '',
        username: '',
        gender: '',
        onHide: noop,
        onComplete: noop
    }
    constructor(props){
        super(props);
        
        this.state = {
            showSelect: false,
            username: props.username,
            gender: props.gender || 1
        }
    }

    componentDidMount() {
        this.showModal();

        this.bindEvent();
    }

    componentWillUnmount(){
        $(document.body).off('click');
    }

    handleSubmit = (e)=>{
        if (this.isFetching) {
            return;
        }

        let username = this.refs.username.value.trim();
        let gender = parseInt(this.refs.gender.value, 10);
                
        if (username == '') {
            notification.simple(lang.template('输入内容不能为空'));
            return;
        }else if(!sensitive.check(username)){
            notification.simple(lang.template('昵称不能出现敏感词'));
            return;
        }

        if (!this.state.code) {
            notification.simple(lang.template('选择国家或地区'));
            this.setState({
                showSelect: true
            });
            return;
        }

        this.isFetching = 1;

        this.setProfile(this.state.code, username, gender);
    }

    setProfile(code, username, gender) {
        loading.show();
        
        let profileset = new ProfileSet({
            countryCode: code,
            username,
            gender
        });

        profileset.promise.then(
            (data)=>{
                loading.hide();
                this.isFetching = 0;
                this.hideModal();
                this.status = 'complete';
                notification.simple(lang.template('个人信息设定成功'));
                
                setTimeout(()=>{
                    $.channel.emit('setCountrySucc');
                }, 1000)
            },
            ()=>{
                loading.hide();
                this.isFetching = 0;
                this.onClose();
                notification.simple(lang.template('个人信息设定失败'));
            }
        );
    }

    handleSelectCountry=()=>{
        if (this.state.showSelect) {
            return;
        }

        this.setState({
            showSelect: true
        });
    }

    bindEvent() {
        let self = this;
        let el = $(this.refs.areaCode);

        el.on({
            mouseenter: function(e) {
                // self.setState({
                //  showSelect: true
                // });
            },
            mouseleave: function(e) {               
                self.setState({
                    showSelect: false
                });
            },
            click: function(e) {                
                self.setState({
                    showSelect: true
                });
            }
        });
        
        $(document.body).on('click', (e)=>{
            let el = $(e.target);
            let showSelect = false;
            
            if ($('.country-list-wrap').find(el).length > 0 || $('.country-list-wrap').find(el).length > 0) {
                showSelect = true;
            }
            this.setState({
                showSelect
            });
        });
    }
    
    onHide() {
        // 在隐藏动画执行完成之后再触发事件onConfirm
        if (this.status == 'complete') {
            this.props.onComplete(this.state.code);
        }
        this.props.onHide();
    }

    onClose() {
        this.hideModal();
        this.status = 'cancel';
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    onSelectOption(data){
        // console.log(data);
        let state = {};
        
        if (!data.code) {
            state = Object.assign({},{showSelect: true}, data);
        } else {
            state = Object.assign({},{showSelect: false}, data);
        }

        this.setState(state);
    }

    moveCaretAtEnd=(e)=>{
        var temp_value = e.target.value
        e.target.value = ''
        e.target.value = temp_value;
    }

    onChange(key, e) {
        let state = this.state
        
        state[key] = e.target.value;

        this.setState(state);
    }

    render() {
        let userInfo = UP.Global.getUser();
        let {username, gender} = this.state;

        return (
            <Modal 
                ref="modal"  
                closeOnClick={false}              
                onHide={this.onHide.bind(this)}
                modalStyle={style.modalStyle}  
                backdropStyle={style.backdropStyle} 
                contentStyle={style.contentStyle}
            >

                <div className="select-country-pop">
                    <div className="box">
                        <div className="pop-hd">
                            {lang.template('个人资料')}
                            <span className="close hidden" onClick={()=>this.onClose()}>x</span>
                        </div>
                        <div className="form">
                            <div className="form-item nickname">
                                <div className="input-label">{lang.template('昵称')}</div>
                                <div className="input-wrap">
                                    <input className="input" 
                                        type="text"
                                        value={username}
                                        ref="username"
                                        maxLength="24"
                                        onChange={(e)=>this.onChange('username', e)}
                                        placeholder={lang.template('请输入昵称')}
                                        onFocus={this.moveCaretAtEnd}
                                    />
                                </div>
                            </div>
                            <div className="form-item gender">
                                <div className="input-label">{lang.template('性别')}</div>
                                <div className="input-wrap">
                                    <select name="gender" ref="gender" defaultValue={gender || 1}>
                                        <option value="1"> {lang.template('男')} </option>
                                        <option value="2"> {lang.template('女')} </option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-item choosecountry" ref="areaCode" onClick={this.handleSelectCountry}>
                                <div className="input-label">{lang.template('国家/地区')}</div>
                                <div className="input-wrap arrow">
                                    <div className="input">
                                    { this.state.inputValue }&lrm;
                                    </div>
                                </div>
                                <CountryView visible={this.state.showSelect} selectOption={this.onSelectOption.bind(this)} ref="countryView"/>
                            </div>
                            <div className="btn" onClick={this.handleSubmit}>
                                {lang.template('确认')}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <SelectCountry {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function(){
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/component/select-country/index.js